export default function ShopTiresFooterSection() {
  return (
    <div className="flex w-full bg-[#F5F5F5] px-8 py-16 sm:mx-auto sm:px-[15rem]">
      <div className="flex flex-col gap-y-8">
        <h3 className="text-[2.1rem] font-semibold text-black">
          Shop Dirt Bike, ATV, UTV, and Motorcycle Tires at MX Locker
        </h3>

        <p className="text-[1.8rem] font-medium text-[#444444]">
          Find the perfect tires for your ride at MX Locker. We offer a wide
          selection of dirt bike, ATV, UTV, and motorcycle tires from top brands
          like Dunlop, Michelin, Bridgestone, and Pirelli. Whether you're
          hitting the motocross track, exploring off-road trails, or cruising on
          the highway, we have tires designed for every terrain and riding
          style.
        </p>

        <p className="text-[1.8rem] font-medium text-[#444444]">
          Shop new and used tires at competitive prices, ensuring you get the
          best performance and durability for your machine. With various tread
          patterns, compounds, and sizes available, MX Locker makes it easy to
          find the right fit for your bike. Upgrade your traction and handling
          today—browse our tire collection now!
        </p>
      </div>
    </div>
  );
}
